import { createAction, props } from '@ngrx/store';

export const setGlobalServiceData = createAction('[Global Service] Set Data', props<any>());

export const getGlobalServiceData = createAction('[Global Service] Get Data', props<any>());
